<template>
    <div id="HomeItem">
        <div @click="headerClick" class="headerArea"><span class="subsTitle">{{data.title}}</span></div>
<!--        <div class="contentArea">-->
<!--            <ul>-->
<!--&lt;!&ndash;                <li v-for="(item, index) in data.content" :key="index">{{item}}</li>&ndash;&gt;-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
  name: 'HomeItem',
  props: ['data'],
  data () {
    return {}
  },
  destroyed () {
  },
  created () {
  },
  methods: {
    headerClick () {
      this.$emit('clickAction')
    }
  }
}
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }
    #HomeItem{
        min-width: 20%;
        max-width: 20%;
        height: auto;
        margin-left: 5%;
        margin-top: 10px;
        .headerArea{
            background-color: #eee;
            padding: 10px;
            min-height: 80px;
            text-align: center;
            align-content: center;
        }
        .contentArea{
            padding: 10px;
            text-align: left;
        }
        .subsTitle{
            line-height: 80px;
        }
    }

</style>
